import { style, transition, trigger } from '@angular/animations';
import { animate } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FeatureFlagsService } from '../../services/feature-flags.service';


@Component({
  selector: 'app-wizard-form-btn',
  standalone: true,

  imports: [CommonModule],
  templateUrl: './wizard-form-btn.component.html',
  styleUrl: './wizard-form-btn.component.css',
  animations: [
    trigger('fadeUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(15px)' }),
        animate('600ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})



export class WizardFormBtnComponent {
  @Input() formInfo!: { btnFunction: any; description: string; btnDisabled: boolean, activeFormNumber: number, showedWizardPagesCount: number };
  googleUser: boolean = false;
  isKissterraCampaign: boolean = false;
  constructor(
    public featureFlagService: FeatureFlagsService) {
        this.googleUser = this.isGoogleUser();
        this.isKissterraCampaign = this.iskissterraCampaign();
     }

     private iskissterraCampaign(): boolean {

      try {
        let urlParms = localStorage.getItem('urlParams');
        if (urlParms) {
          let urlParams = JSON.parse(urlParms);
          if (urlParams && urlParams['Campaign ID']) {
            if (urlParams['Campaign ID'] === '120215998472560352') {
              return true;
            }
          }
        }
      } catch (e) {
        console.log('Error on iskissterraCampaign ' + JSON.stringify(e));
      }
      return false;
  
    }

     private isGoogleUser(): boolean {
      try {
        let urlParms = localStorage.getItem('urlParams');
        if (urlParms) {
          let urlParams = JSON.parse(urlParms);
          if (urlParams && urlParams['utm_source']) {
            if (urlParams['utm_source'] === 'googleads') {
              return true;
            }
          }
        }
      } catch (e) {
        console.log('Error on isGoogleUser ' + JSON.stringify(e));
      }
      return false;
    }
  
}
